import { ProbabilitiesTable } from "../Inspect/ProbabilitiesTable";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample1009300() {
  const probabilities5313 = {
    RICHARD: 30 / 100,
    ELIZABETH: 26 / 100,
    BUCKINGHAM: 14 / 100,
    NORTHUMBERLAND: 9 / 100,
    GLOUCESTER: 8 / 100,
    PETRUCHIO: 5 / 100,
  };
  const labels5313 = {
    RICHARD: <SampleQuote text="RICHARD" targetIdx={2} ellipsis={false} quotes={false} />,
    ELIZABETH: <SampleQuote text="ELIZABETH" targetIdx={7} ellipsis={false} quotes={false} />,
    BUCKINGHAM: <SampleQuote text="BUCKINGHAM" targetIdx={6} ellipsis={false} quotes={false} />,
    NORTHUMBERLAND: (
      <SampleQuote text="NORTHUMBERLAND" targetIdx={3} ellipsis={false} quotes={false} />
    ),
    GLOUCESTER: <SampleQuote text="GLOUCESTER" targetIdx={4} ellipsis={false} quotes={false} />,
    PETRUCHIO: <SampleQuote text="PETRUCHIO" targetIdx={5} ellipsis={false} quotes={false} />,
  };

  const probabilities688 = {
    RICHARD: 17 / 38,
    PETRUCHIO: 14 / 38,
    Richard: 3 / 38,
    RICHMOND: 3 / 38,
    Richmond: 1 / 38,
  };
  const labels688 = {
    RICHARD: <SampleQuote text="RICHARD" targetIdx={2} ellipsis={false} quotes={false} />,
    PETRUCHIO: <SampleQuote text="PETRUCHIO" targetIdx={5} ellipsis={false} quotes={false} />,
    Richard: <SampleQuote text="Richard" targetIdx={2} ellipsis={false} quotes={false} />,
    RICHMOND: <SampleQuote text="RICHMOND" targetIdx={2} ellipsis={false} quotes={false} />,
    Richmond: <SampleQuote text="Richmond" targetIdx={2} ellipsis={false} quotes={false} />,
  };

  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="1009300" />
        <span> - </span>
        <SampleQuote text="PETRUCHIO" targetIdx={5} />
      </h4>
      <p>
        For this sample, the 6-layer GPT-2 model predicts a letter “H” with 100% certainty. The last
        layer contains 10 active features. Most of these fire upon specific letters within a
        character’s name. Together, they maximally fire upon letters preceding an “H” in words like
        “RICHARD”, “ELIZABETH”, and “BUCKINGHAM”. Naively, one may expect that a different ensemble
        of features would be needed for each unique sequence of letters; however, compressive
        pressures may be incentivizing the construction of features representing more complex
        patterns.
      </p>
      <div className="figures">
        <figure>
          <figcaption>
            Sequences Triggering{" "}
            <FeatureAnchor modelId="baby-v1" sampleId="1009300" featureKey="0.5.5313" />
          </figcaption>
          <ProbabilitiesTable probabilities={probabilities5313} labels={labels5313} limit={6} />
        </figure>
        <figure>
          <figcaption>
            Sequences Triggering{" "}
            <FeatureAnchor modelId="baby-v1" sampleId="1009300" featureKey="0.6.688" />
          </figcaption>
          <ProbabilitiesTable probabilities={probabilities688} labels={labels688} />
        </figure>
      </div>
    </section>
  );
}

export { Sample1009300 };
